import React from 'react'
import styled from 'styled-components'
import currencyParser from '../../../helpers/currency'
import CreateInput from '../../components/input'
import { Alert } from '@material-ui/lab'
import { Fade } from '@material-ui/core'
import propTypes from 'prop-types'
import { category } from '../../../config'

const GeneralInfo = (props) => {
  if (props.currentStep !== 0) return null

  return (
    <Content>
      <Fade in={props.errors.length !== 0}>
        <GroupForm>
          <Alert severity='error'>Todos los campos son requeridos</Alert>
        </GroupForm>
      </Fade>

      <GroupForm>
        <Label>Nombre de la prueba</Label>
        <TitleInput
          type='text'
          name='title'
          {...props}
        />
      </GroupForm>

      <GroupForm>
        <Label>Categoria</Label>
        <TitleInput
          type='select'
          name='category'
          {...props}
          options={category}
          size='large'
        />
      </GroupForm>

      <GroupForm>
        <Label>¿Cuál es el precio de tu producto?</Label>
        <TitleInput
          value={props.price ? currencyParser.toCurrency(props.price) : ''}
          onChange={({ name, value }) => props.handleChange({ name, value: currencyParser.toNumber(value) })}
          type='text'
          name='price'
          {...props}
        />
      </GroupForm>

    </Content>
  )
}

GeneralInfo.propTypes = {
  errors: propTypes.array,
  currentStep: propTypes.number,
  price: propTypes.number,
  handleChange: propTypes.func
}

const Content = styled('div')`
  max-width: 800px;
  margin: auto;
`
const GroupForm = styled('div')`
  margin: auto;
  margin-bottom: 20px;
  width: 80%;
  @media screen and (max-width: 500px) {
    width: 100%;
  }
`
const Label = styled('div')`
  color: var(--main-blue-dark);
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 1.1em;
`
const TitleInput = styled(CreateInput)`
  width: 100%;
  .MuiTextField-root{
    color: red
  }
`

export default GeneralInfo
